mutation updatePositions($leadIds: [ID]!) {
  response: updatePositions(leadIds: $leadIds)
}
